import { Skeleton } from './Skeleton';

interface SkeletonChartProps {
  type?: 'bar' | 'line' | 'pie' | 'area';
  className?: string;
  showLegend?: boolean;
  showTitle?: boolean;
  height?: number;
}

export function SkeletonChart({
  type = 'bar',
  className = '',
  showLegend = true,
  showTitle = true,
  height = 300
}: SkeletonChartProps) {
  const renderChartSkeleton = () => {
    switch (type) {
      case 'pie':
        return (
          <div className="flex items-center justify-center">
            <Skeleton width="200px" height={200} className="rounded-full" />
          </div>
        );
      
      case 'line':
      case 'area':
        return (
          <div className="space-y-2">
            {/* Lignes de graphique */}
            <div className="flex items-end space-x-1 h-40">
              {Array.from({ length: 8 }).map((_, i) => (
                <Skeleton 
                  key={i} 
                  width="12%" 
                  height={Math.random() * 80 + 40} 
                  className="rounded-t" 
                />
              ))}
            </div>
            {/* Axe X */}
            <div className="flex justify-between">
              {Array.from({ length: 8 }).map((_, i) => (
                <Skeleton key={i} width="20px" height={12} />
              ))}
            </div>
          </div>
        );
      
      default: // bar
        return (
          <div className="space-y-2">
            {/* Barres du graphique */}
            <div className="flex items-end space-x-2 h-40">
              {Array.from({ length: 6 }).map((_, i) => (
                <Skeleton 
                  key={i} 
                  width="16%" 
                  height={Math.random() * 120 + 40} 
                  className="rounded-t" 
                />
              ))}
            </div>
            {/* Labels de l'axe X */}
            <div className="flex justify-between">
              {Array.from({ length: 6 }).map((_, i) => (
                <Skeleton key={i} width="40px" height={12} />
              ))}
            </div>
          </div>
        );
    }
  };

  return (
    <div className={`bg-white rounded-lg shadow-md p-4 sm:p-6 ${className}`} style={{ height }}>
      {showTitle && (
        <div className="mb-4">
          <Skeleton width="40%" height={24} className="mb-2" />
          <Skeleton width="60%" height={16} />
        </div>
      )}
      
      <div className="flex-1">
        {renderChartSkeleton()}
      </div>
      
      {showLegend && (
        <div className="mt-4 flex flex-wrap gap-4">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="flex items-center space-x-2">
              <Skeleton width="12px" height={12} className="rounded-full" />
              <Skeleton width="60px" height={16} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
